import React from 'react';
import _Image from '../classes/konva/_Image';
import Helper from '../classes/Helper';
import ImageCrop from './ImageCrop';
import ImageCropPortal from './ImageCropPortal';
import CreatorModal from './CreatorModal';
import Translation from "../classes/Translation";



export default class ImageThumb extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageSrc: this.getInitialImageSrcFromLayer(),
      saveChanges: false,
      modalVisible: false,
      resolutionWarning: false,
      initialCrop: false,
      isCropSizeTooSmall: 0,
    }

    this.imageUpload = React.createRef();
    this.handleBtnAddClick = this.handleBtnAddClick.bind(this);
    this.handleBtnEditClick = this.handleBtnEditClick.bind(this);

    this.handleInputChange = this.handleInputChange.bind(this);

    this.setIds();
    this.imageResolution = null;
    this.minImageResolution = this.getMinResolutionFromLayer();
    this.initialImage = this.getInitialImageSrcFromLayer();
  }

  setIds(){
    this.idPrefix = 'formFile' + this.props.index;

    this.ids = [];
    this.ids.wrapperId = this.idPrefix + '__wrapper';
    this.ids.containerId = this.idPrefix + '__container';
    this.ids.thumbnailId = this.idPrefix + '__thumbnail';
    this.ids.modalId = this.idPrefix + '__modal';
    this.ids.modalCloseId = this.idPrefix + '__modal--close';
  }

  componentDidMount() {
    window.addEventListener("resize", this.reRenderCropStage);
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.reRenderCropStage);
  }

  getStageId() {
    return this.props.layer.getParent()._id;
  }

  getLayerId() {
    return this.props.layer.id();
  }

  getWrapperId() {
    return this.ids.wrapperId;
  }

  getContainerId() {
    return this.ids.containerId;
  }

  getThumbnailId() {
    return this.ids.thumbnailId;
  }

  getInitialImageSrcFromLayer() {
    let group = this.props.layer.getChildren(function (node) {
      return node.getChildren(function (node2) {
        return node2 instanceof _Image;
      });
    });
    if (group.length == 0) return;

    let images = group[0].getChildren(function (node) {
      return node instanceof _Image;
    });
    if (images.length == 0) return;

    let imageSrc = images[0].getAttr('image_src');
    return imageSrc;
  }

  getMinResolutionFromLayer() {
    let layer = this.props.layer.findOne('.content');
    return {
      width: Number(layer.getAttr('min_width')),
      height: Number(layer.getAttr('min_height')),
    }
  }

  setImageSrcForLayer(imageSrc) {
    let img = Helper.loadImage(imageSrc,
      () => {
        this.props.layer.findOne('.content').setImageObject(img);
        this.props.layer.draw();
  
        this.props.rerenderCustomizationInputs(() => {
          this.handleBtnCloseClick();
        });
      },
      (err) => {
        alert("Nie udało się wczytać zdjęcia. Skontaktuj się z obsługą sklepu.")
      }
    );
  }

  updateImage = (image) => {
    if (this.state.saveChanges == true) {
      this.setState({resolutionWarning: false}, () => {
        this.setImageSrcForLayer(image);
      });
    }
  }

  handleBtnAddClick(e) {
    this.imageUpload.current.click();
  }

  handleBtnEditClick = () => {
    this.setState({ modalVisible: true, initialCrop: false });
  }

  handleBtnCloseClick = () => {
    this.setState({ modalVisible: false, initialCrop: false });
  }

  handleInputChange(e) {
    let image = URL.createObjectURL(e.target.files[0]);
    setTimeout(()=>{
      this.setState({
        currentImageSrc: image,
        saveChanges: true,
        resolutionWarning: false,
        modalVisible: true
      });
    }, 500);
  }

  reRenderCropStage = (e) => {
    if (this.state.modalVisible === false) return;
    
    this.setState({modalVisible: false}, () => {
      this.setState({modalVisible: true})
    })
  }



  render() {
    const { saveChanges } = this.state;
    
    return (
      <div id={this.getWrapperId()} className='photo'>
        <div id={this.getContainerId()} className="imageWrapper">
          <img id={this.getThumbnailId()}
            src={this.state.currentImageSrc}
          />
        </div>
        {/* {this.state.resolutionWarning &&
          <div className="alert alert-warning" style={{lineHeight: 'normal'}}>
            Rozdzielczość zdjęcia {this.getImageResolution()} może być zbyt niska. Minimalna rozdzielczość to {this.getMinResolution()}.
          </div>
        } */}
        {/* <div className='card-body'> */}
          <div className='input-group text-center'>
            <input className="form-control d-none" type="file" style={{ display: 'none' }}
              ref={this.imageUpload}
              onChange={this.handleInputChange}
              accept=".png, .jpg, .jpeg"
            />
            <div className="btn-group">
              <button type="button" className="btn btn-primary" title="Add"
                data-type="add"
                onClick={this.handleBtnAddClick}
              >
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16"><path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" /></svg> */}
                { Translation.getTranslation(`load`) }
              </button>
              { saveChanges &&
                <button type="button" className="btn btn-primary" title="Crop" 
                  data-type="edit"
                  onClick={this.handleBtnEditClick}
                >
                  { Translation.getTranslation(`edit`) }
                </button>
              }
              {/* <button type="button" className="btn btn-primary" title="Delete"
                data-type="delete"
                onClick={this.handleBtnRemoveClick}
              > */}
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" /><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" /></svg> */}
                {/* Usuń
              </button> */}
            </div>
          </div>
        {/* </div> */}
        { (this.state.modalVisible || this.state.initialCrop) &&
            <ImageCropPortal>
              <CreatorModal
                visibility={true}
                hide={this.state.initialCrop}
                id={this.ids.modalId}
                closeModal={this.handleBtnCloseClick}
                title={ Translation.getTranslation(`selectPark`) }
                scrollPositionToSliderContainerAfterUnmount={true}
                content={
                  <ImageCrop
                    imageSrc={this.state.currentImageSrc}
                    minImageSize={this.minImageResolution}
                    updateImageCallback={this.updateImage}
                    closeModal={this.handleBtnCloseClick}
                    layer={this.props.layer}
                    ids={this.ids}
                    initialCrop={this.state.initialCrop}
                  />
                }
              />
            </ImageCropPortal>
        }
      </div>
    );
  }
}
